import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { Workbox } from 'workbox-window';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service Worker registration using Workbox

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const wb = new Workbox('/service-worker.js');
    wb.register();

    wb.addEventListener('waiting', () => {
      // New SW waiting to activate
      showUpdateBanner();
    });

    wb.addEventListener('externalwaiting', () => {
      showUpdateBanner();
    });

    wb.addEventListener('activated', (event) => {
      if (!event.isUpdate) {
        hideUpdateBanner();
      }
    });
  });
}

// Offline indicator
window.addEventListener('offline', () => {
  showOfflineIndicator();
});
window.addEventListener('online', () => {
  hideOfflineIndicator();
});

function showOfflineIndicator() {
  let el = document.getElementById('offline-indicator');
  if (!el) {
    el = document.createElement('div');
    el.id = 'offline-indicator';
    el.textContent = 'You are offline';
    el.style.position = 'fixed';
    el.style.bottom = '0';
    el.style.left = '0';
    el.style.right = '0';
    el.style.background = '#ef4444';
    el.style.color = '#fff';
    el.style.textAlign = 'center';
    el.style.padding = '8px';
    el.style.zIndex = '9999';
    document.body.appendChild(el);
  }
}
function hideOfflineIndicator() {
  const el = document.getElementById('offline-indicator');
  if (el) document.body.removeChild(el);
}

// Update banner
function showUpdateBanner() {
  let el = document.getElementById('update-banner');
  if (!el) {
    el = document.createElement('div');
    el.id = 'update-banner';
    el.textContent = 'A new version is available. Click to update.';
    el.style.position = 'fixed';
    el.style.top = '0';
    el.style.left = '0';
    el.style.right = '0';
    el.style.background = '#fbbf24';
    el.style.color = '#111827';
    el.style.textAlign = 'center';
    el.style.padding = '8px';
    el.style.zIndex = '9999';
    el.style.cursor = 'pointer';
    el.onclick = () => {
      if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    };
    document.body.appendChild(el);
  }
}

function hideUpdateBanner() {
  const el = document.getElementById('update-banner');
  if (el) document.body.removeChild(el);
}

// Install prompt
let deferredPrompt;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  showInstallPrompt();
});
function showInstallPrompt() {
  let el = document.getElementById('install-prompt');
  if (!el) {
    el = document.createElement('div');
    el.id = 'install-prompt';
    el.textContent = 'Install this app for offline access.';
    el.style.position = 'fixed';
    el.style.bottom = '40px';
    el.style.left = '0';
    el.style.right = '0';
    el.style.background = '#34d399';
    el.style.color = '#111827';
    el.style.textAlign = 'center';
    el.style.padding = '8px';
    el.style.zIndex = '9999';
    el.style.cursor = 'pointer';
    el.onclick = () => {
      if (deferredPrompt) {
        deferredPrompt.prompt();
        deferredPrompt = null;
        document.body.removeChild(el);
      }
    };
    document.body.appendChild(el);
  }
}
